
import React from 'react';
import { Button } from '@/components/ui/button';
import { UserPlus, RefreshCw } from 'lucide-react';
import { toast } from 'sonner';

interface UserManagementHeaderProps {
  onRefresh: () => void;
  onOpenInviteDialog: () => void;
}

export const UserManagementHeader: React.FC<UserManagementHeaderProps> = ({
  onRefresh,
  onOpenInviteDialog
}) => {
  return (
    <div className="flex justify-between items-center mb-6">
      <h1 className="text-2xl font-bold">User Management</h1>
      <div className="flex space-x-2">
        <Button
          variant="outline"
          size="icon"
          onClick={() => {
            onRefresh();
            toast.success("User list refreshed");
          }}
          title="Refresh user list"
        >
          <RefreshCw className="h-4 w-4" />
        </Button>
        <Button onClick={onOpenInviteDialog}>
          <UserPlus className="mr-2 h-4 w-4" />
          Add User
        </Button>
      </div>
    </div>
  );
};
